
export const bulletins = {
  columns: {
    title: {
      field: 'title',
      label: 'Title'
    },
    bulletin_id: {
      field: 'field_bulletin_id',
      label: 'Bulletin ID'
    },
    category: {
      field: 'field_bulletin_category',
      label: 'Category'
    },
    posted: {
      field: 'field_publication_date',
      label: 'Date Posted'
    },
    // archived: {
    //   field: 'field_archive_date',
    //   label: 'Date Archived'
    // },
  }
}